import {
  CloseIconButton as ExprWorksCloseIconButton,
  CloseIconButtonProps as ExprWorksCloseIconButtonProps,
} from '@diagentech/exprworks-ui-components';
import React from 'react';

type CloseIconButtonProps = Omit<ExprWorksCloseIconButtonProps, 'ariaLabelId'>;

export const CloseIconButton: React.FC<CloseIconButtonProps> = (props) => (
  <ExprWorksCloseIconButton ariaLabelId="SH.BTN.CLOSE" {...props} />
);
